import React from "react";
import { Container, Content, SecondContainer } from "../../ChatPanel.styled";
import { Typography, ChatInput } from "@ann/web-components";
import { CHAT_INPUT_ADD_MENU_ITEMS } from "../../constants";

const EmptyStateView = ({
  attachments,
  onFilesSelected,
  onAttachmentRemove,
  onAddMenuChange,
  onModeMenuChange,
}) => {
  return (
    <Container>
      <Content>
        <Typography category="title" size="medium" weight="bold">
          How can I help you today?
        </Typography>
        <SecondContainer>
          <ChatInput
            className={"chat-input"}
            placeholder="Ask anything"
            allowUploadFiles
            attachments={attachments}
            onFilesSelected={onFilesSelected}
            onAttachmentRemove={onAttachmentRemove}
            onAddMenuChange={onAddMenuChange}
            onModeMenuChange={onModeMenuChange}
            addMenuItems={CHAT_INPUT_ADD_MENU_ITEMS}
            isProcessing={false}
          />
        </SecondContainer>
      </Content>
    </Container>
  );
};

export default EmptyStateView;
